import { FormGroup, FormArray } from '@angular/forms';
import { FormSubmission } from 'app/models/form-submission';
import { WorkflowExec } from 'app/models/workflow-exec';
import { WorkflowExecVariable } from 'app/models/workflow-exec-variable';
import { timeZoneNames } from 'app/helpers/timezone-options';

export function convertObjectArrayToIdArray(items: any[]) {
    let ids: any[] = [];

    (items && items.forEach(i => {
        if (i.id)
        ids.push(i.id);
    }));

    return ids;
}

export function formGroupPatchValueNullFriendly(frmGroup: FormGroup, value: {[key: string]: any}, options: {onlySelf?: boolean, emitEvent?: boolean} = {}): void {
    Object.keys(value).forEach(name => {
        if (frmGroup.controls[name]) {
            if (value[name] != undefined && value[name] != null) {
                if (frmGroup.controls[name] instanceof FormGroup) {
                    formGroupPatchValueNullFriendly(frmGroup.controls[name] as FormGroup, value[name], options);
                }
                else if (frmGroup.controls[name] instanceof FormArray) {
                    formArrayPatchValueNullFriendly(frmGroup.controls[name] as FormArray, value[name] as any[], options);
                }
                else {
                    frmGroup.controls[name].patchValue(value[name], {onlySelf: options.onlySelf, emitEvent: options.emitEvent});
                }
            } else {
                frmGroup.controls[name].reset();
            }
        }
    });
    frmGroup.updateValueAndValidity(options);
}

export function formArrayPatchValueNullFriendly(frmArray: FormArray, value: any[], options: {onlySelf?: boolean, emitEvent?: boolean} = {}): void {
    value.forEach((newValue: any, index: number) => {
        if (frmArray.at(index)) {
            if (newValue != undefined && newValue != null) {
                var frm = frmArray.at(index);
                if (frm instanceof FormGroup) {
                    formGroupPatchValueNullFriendly(frm, newValue, options);
                } else if (frm instanceof FormArray) {
                    formArrayPatchValueNullFriendly(frm, newValue, options);
                } else {
                    frmArray.at(index).patchValue(newValue, {onlySelf: options.onlySelf, emitEvent: options.emitEvent});
                }
            } else {
                frmArray.at(index).reset();
            }
        }
      });
      frmArray.updateValueAndValidity(options);
}

export function loopOnComponents(component: any, callback: (cmp: any, submissionPrefix: string) => void, submissionPrefix: string = '') : void {
    if (component.type == 'columns') {
      component.columns.forEach(col => {
        col.components && col.components.forEach(child => {
          loopOnComponents(child, callback, submissionPrefix);
        });
      });
    } else if (component.type == 'tabs') {
      component.components.forEach(tab => {
        tab.components && tab.components.forEach(child => {
          loopOnComponents(child, callback, submissionPrefix);
        });
      });
    } else if (component.type == 'table') {
      component.rows.forEach(row => {
        row.forEach(cell => {
          cell.components && cell.components.forEach(child => {
            loopOnComponents(child, callback, submissionPrefix);
          });
        });
      });
    } else if (component.type == 'datagrid') {
      if (component.components) {
        component.components.forEach(child => {
          loopOnComponents(child, callback, component.key + '.0.');
        });
      }
    }  else if (component.type == 'container') {
      if (component.components) {
        component.components.forEach(child => {
          loopOnComponents(child, callback, component.key + '.');
        });
      }
    } else if (component.components || component.type == 'form' || component.type == 'fieldset' ||
              component.type == 'panel' || component.type == 'well' ||
              component.type == 'editgrid' || component.type == 'tree') {
                if (component.components) {
                  component.components.forEach(child => {
                    loopOnComponents(child, callback, submissionPrefix);
                  });
                }
    } else {
      callback(component, submissionPrefix);
    }
  }

  export function castDates(model: any, dateFields: string[] = ['updated_at', 'created_at']) {
    dateFields.forEach((key) => {
      model[key] && (model[key] = new Date(model[key]));
    });
  }

  export function getExecVariableValue(workflowExec: WorkflowExec, workflowExecVariable: WorkflowExecVariable) : any[] {
    if (!workflowExec || !workflowExec.form_submissions || workflowExec.form_submissions.length == 0 ||
        !workflowExecVariable) {
      return [];
    }

    let formSubmission: FormSubmission = workflowExec.form_submissions.find((f) => f.name == workflowExecVariable.workflow_form_name);
    if (!formSubmission) {
      return [];
    }

    let result : any[] = [];

    workflowExecVariable.fields.forEach((field) => {
      if (formSubmission.value && formSubmission.value[field.field_name]) {
        let fieldValue = formSubmission.value[field.field_name];

        if (Array.isArray(fieldValue)) {
          if (!result) {
            result = fieldValue;
          } else {
            result = result.concat(fieldValue);
          }
        } else {
          if (!result) {
            result = [fieldValue];
          } else {
            result.push(fieldValue);
          }
        }
      }
    });

    return result;
  }

  export function unescapeHtml(unsafe) {
    return unsafe
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, "\"")
        .replace(/&#039;/g, "'");
  }

  export function getDefaultTimezone() {
    let clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (timeZoneNames.includes(clientTimezone))
        return clientTimezone;
    else
        return 'UTC';
  }

  export function getObjectProperty(object: any, path: string) {
    return path.split('.').reduce ( (res, prop) => ((res && res[prop]) || null), object );
  }

  export function initiateDownload(url: string) {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', '');

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);    
  }

  export function getSpecialPages() {
    return [
      '/login',
      '/logout',
      '/register',
      '/lock',
      '/pages/pricing',
      '/pages/single-post',
      '/pages/post-listing',
      '/reset-password',
      '/verify-email',
      '/site',
      '/accounts/authorize',
      '/accounts/support/sso',
      '/external',
      '/gen/form',
      '/wopi',
      '/pdf',
      '/registration-progress'
    ];
  }

  export function isSpecialPage() {
    let result: boolean = false;
    let specialPages: string[] = getSpecialPages();
    specialPages.forEach((v) => {
      if (window.location.pathname.startsWith(v)) {
        result = true;
      }
    });

    return result;
  }